<template>
  <div
    v-if="selectedFabric.id"
    class="selected-item-inner col-span-4 px-5 py-8 lg:p-0 flex gap-4 justify-start items-start"
  >
    <div class="selected-image w-full">
      <img :alt="selectedFabric.name" :src="selectedFabric.image" class="object-cover w-full" />
    </div>
    <div class="flex flex-col lg:flex-row gap-2 lg:gap-x-10 items-start w-full">
      <div class="flex flex-col gap-2 mb-2">
        <span class="font-semibold text-lg min-h-16 lg:text-2xl">
          {{ selectedItemFullName }}
        </span>
        <DialogDescription><span class="text-black text-sm lg:text-base">{{ $t('Material on top, sides & buttons') }} </span></DialogDescription>
      </div>
      <button type="button" class="btn btn-primary px-9 py-4" @click="setSelectedFabrics">
      {{ $t('OK') }}
    </button>
    </div>

  </div>
  <div v-if="!selectedFabric.id" class="selected-item-inner hidden col-span-4 px-5 py-8 lg:p-0 lg:flex gap-4 justify-start items-start">
    <div class="w-full h-1/2 border border-black/20 text-black/60 flex justify-center items-center">
      <span>{{ $t('The color is not selected') }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useStore } from '../../stores/store'
import { computed } from 'vue'
import { usePopup } from '@/stores/popup'
import { DialogDescription } from '../ui/dialog'

const store = useStore()
const popups = usePopup()
const { selectedFabric, fabrics } = storeToRefs(store)
const selectedItemFullName = computed(() => {
  return selectedFabric.value.name
})

function setSelectedFabrics() {
  fabrics.value.data = selectedFabric.value
  popups.materialPopup = false
}
</script>

<style scoped>
.selected-item-inner {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: white;
  width: 100%;
}

.selected-image {
  max-width: 50px;
  display: none;
}
.selected-image img {
  border-radius: 999px;
}
.arrow-material {
  height: max-content;
  margin-bottom: 15px;
}


.selected-name {
  font-weight: 600;
  font-size: 12px;
}

@media (min-width: 1024px) {
  .selected-item-inner {
    position: relative;
    flex-direction: column;
    justify-content: start;
    max-width: 368px;
  }

  .selected-name {
    font-weight: 600;
    font-size: 24px;
  }

  .selected-image {
    max-width: none;
    display: block;
  }
  .selected-image img {
    border-radius: unset;
    max-height: 400px;
  }
}
</style>
